import { z } from "zod";
import { AlgorithmId, LevelDefinition, StageId } from "@algoquest/schemas";

/**
 * `levels` domain DTOs (Master Spec §33/§39, Phase 10). Phase 15 ("100-
 * level campaign production") is what actually authors the 100 official
 * levels; until then, `game_levels` rows are bootstrapped lazily by
 * whichever `LevelDefinition` the game client is currently playing (the
 * same prototype fixtures every phase since 02 has used), so the Phase
 * 10 sync pipeline (`attempts`/`progress`) has a real `game_levels.id` to
 * attach to. `UpsertLevelRequestSchema` is that bootstrap request — see
 * `levels.repository.ts`'s `upsertLevel` for why this is insert-if-
 * missing, never an overwrite, so it can never clobber Phase 15's later
 * authored content.
 */
export const UpsertLevelRequestSchema = z.object({
  definition: LevelDefinition,
});
export type UpsertLevelRequest = z.infer<typeof UpsertLevelRequestSchema>;

export const LevelSummaryDTOSchema = z.object({
  id: z.string().uuid(),
  globalLevelNumber: z.number().int().min(1).max(100),
  stage: StageId,
  world: z.number().int().min(1).max(10),
  levelInWorld: z.number().int().min(1).max(10),
  algorithm: AlgorithmId,
  definition: LevelDefinition,
});
export type LevelSummaryDTO = z.infer<typeof LevelSummaryDTOSchema>;

export const UpsertLevelResponseSchema = z.object({
  level: LevelSummaryDTOSchema,
});
export type UpsertLevelResponse = z.infer<typeof UpsertLevelResponseSchema>;

export const ListLevelsResponseSchema = z.object({
  levels: z.array(LevelSummaryDTOSchema),
});
export type ListLevelsResponse = z.infer<typeof ListLevelsResponseSchema>;
